module.exports = __webpack_public_path__ + "static/ja-245a616bf5b6abd82fac9287f1589fa1.png";